import { BaseSnapshotModel } from "../BaseSnapshotModel";

export class MentalHealthSnapshotModel extends BaseSnapshotModel {
  constructor() {
    super();
    this.Model = {
      modelFields: [
        "assessments_and_reminders_email",
        "assessments_and_reminders_notifications"
      ],

      requiredFields: []
    };
  }
}
